define('services/TemplatePageService',['app', 'modules/module', 'services/EntityCrudService'], function (app, module) {
	'use strict';
	return module.factory('TemplatePageService', ['$injector', TemplatePageService]);
});

function TemplatePageService($injector) {
	crudInstance = $injector.instantiate(CrudService);
	crudInstance.setType('TemplatePage');

	angular.extend(this, crudInstance);

	return this;
}
;
